// extracted by mini-css-extract-plugin
module.exports = {"industryCard":"IndustryCard_industryCard__pX3Qk","industryCard__image":"IndustryCard_industryCard__image__ZMsPI","industryCard__title":"IndustryCard_industryCard__title__e0mY9"};